export default "__VITE_ASSET__iX42DAF4__"